var _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconMute = function SvgIconMute(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5735 14.7491C22.5735 14.3392 22.2309 14.0068 21.8082 14.0068C21.3855 14.0068 21.0429 14.3392 21.0429 14.7491C21.0429 18.3806 17.9976 21.3348 14.2542 21.3348C10.511 21.3348 7.46571 18.3806 7.46571 14.7491C7.46571 14.3392 7.12309 14.0068 6.70039 14.0068C6.27768 14.0068 5.93506 14.3392 5.93506 14.7491C5.93506 18.949 9.25911 22.409 13.4889 22.7851V24.7837H10.6488C10.2261 24.7837 9.88347 25.1161 9.88347 25.5262C9.88347 25.9362 10.2261 26.2686 10.6488 26.2686H17.8598C18.2823 26.2686 18.6249 25.9362 18.6249 25.5262C18.6249 25.1161 18.2823 24.7837 17.8598 24.7837H15.0195V22.7851C19.2495 22.4092 22.5735 18.949 22.5735 14.7491Z",
    fill: "#F34D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2541 19.5029C16.9562 19.5029 19.1545 17.3704 19.1545 14.7492V6.12762C19.1545 3.50657 16.9562 1.37402 14.2541 1.37402C11.5523 1.37402 9.354 3.50657 9.354 6.12762V14.7492C9.354 17.3704 11.5523 19.5029 14.2541 19.5029Z",
    fill: "#F34D4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.0516,
    y: 0.141417,
    width: 2.33642,
    height: 34.9598,
    rx: 1.16821,
    transform: "rotate(45.442 25.0516 0.141417)",
    fill: "#F34D4F",
    stroke: "white",
    strokeWidth: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMute, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mute.68a3bb71.svg";
export { ForwardRef as ReactComponent };